import { checkResponse, getYYYYMMDD, hashCode, parseJSONDate } from "src/components/js/statics1";
import asiakasAuthClass from "src/data/auth/asiakasAuthClass";
import {
  asiakasPerson_cacheName,
  cache_clear,
  cache_read,
  cache_write,
} from "src/components/js/CacheFunctions";
import sijaintiClass from "../sijainti/sijaintiClass";
import { asiakasSetting_set, asiakasSettings_get } from "./AsiakasSettingsFunctions";
import personSettingsClass from "../person/personSettingsClass";

export default class asiakasClass {
  constructor(asiakasId = 0) {
    this.asiakasId = asiakasId;
    this.asiakasNimi = "";
    this.ytunnus = "";
    this.kommentti = "";
    this.asiakasContactPersonId = 0;
    this.auth = new asiakasAuthClass();
    this.originalHash = "";
    this.colorCode = "";
    this.isTyomaaAsiakas = true;
    this.isPumppuToimittaja = false;
    this.isBetoniToimittaja = false;
    this.isLattiaToimittaja = false;
    this.asiakasContactPersonPhone = undefined;
    this.asiakasContactPersonEmail = undefined;
    this.sijaintiId = 0; // 0 = ei sijaintia. Käytetään keikkaData.pumppuToimittajassa ja keikkaData.betoniToimittajassa
    this.sijaintiMatkaM = 0; // matka sijainnista työmaalle
    this.sijaintiMatkaAika = 0; // matka-aika sijainnista työmaalle
    this.isLoaded = false;
    this.settings = []; // new asiakasSettingsClass(asiakasId, laskuttajaAsiakasId);
    this.ownerAsiakasId = null;
    this.sijainti = new sijaintiClass();
    this.varikkoSijaintiId = null;
  }
  setSettingsFromJson(jsonData) {
    try {
      this.settings = jsonData;
    } catch (err) {
      console.log(err);
    }
  }
  setModulesFromJson(jsonData) {
    try {
      this.modules = jsonData;
    } catch (err) {
      console.log(err);
    }
  }

  setDataFromJson(jsonData) {
    if (jsonData === undefined) return;
    if (jsonData[0] !== undefined && jsonData[0].asiakasId !== undefined) jsonData = jsonData[0];
    try {
      this.asiakasId = jsonData.asiakasId;
      this.asiakasNimi = jsonData.asiakasNimi;
      this.ytunnus = jsonData.ytunnus;
      this.kommentti = jsonData.kommentti;
      this.asiakasContactPersonId = jsonData.asiakasContactPersonId;
      this.asiakasContactPersonPhone = jsonData.asiakasContactPersonPhone;
      this.asiakasContactPersonEmail = jsonData.asiakasContactPersonEmail;
      this.tyomaaOsoite1 = jsonData.tyomaaOsoite1;
      this.tyomaaOsoite2 = jsonData.tyomaaOsoite2;
      this.tyomaaOsoite3 = jsonData.tyomaaOsoite3;
      this.tyomaaOsoite4 = jsonData.tyomaaOsoite4;
      this.isBetoniToimittaja = jsonData.isBetoniToimittaja;
      this.isTyomaaAsiakas = jsonData.isTyomaaAsiakas;
      this.isPumppuToimittaja = jsonData.isPumppuToimittaja;
      this.isLattiaToimittaja = jsonData.isLattiaToimittaja;
      this.isLoaded = true;
      this.ownerAsiakasId = jsonData.asiakas_ownerAsiakasId;
      this.varikkoSijaintiId = jsonData.varikkoSijaintiId;
      this.colorCode = jsonData.colorCode;
    } catch (err) {
      console.log(err);
    }
  }

  setAsiakas(obj) {
    this.asiakasId = obj.asiakasId;
    this.asiakasNimi = obj.asiakasNimi;
    this.ytunnus = obj.ytunnus;
    this.kommentti = obj.kommentti;
    this.asiakasContactPersonId = obj.asiakasContactPersonId;
    this.tyomaaOsoite1 = obj.tyomaaOsoite1;
    this.tyomaaOsoite2 = obj.tyomaaOsoite2;
    this.tyomaaOsoite3 = obj.tyomaaOsoite3;
    this.tyomaaOsoite4 = obj.tyomaaOsoite4;
    this.isTyomaaAsiakas = obj.isTyomaaAsiakas;
    this.isBetoniToimittaja = obj.isBetoniToimittaja;
    this.isPumppuToimittaja = obj.isPumppuToimittaja;
    this.asiakasContactPersonEmail = obj.asiakasContactPersonEmail;
    this.asiakasContactPersonPhone = obj.asiakasContactPersonPhone;
    this.varikkoSijaintiId = obj.varikkoSijaintiId;
    this.isloaded = true;
  }

  async saveAsiakasRoolitToDb(token) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        asiakasId: this.asiakasId,
        isTyomaaAsiakas: this.isTyomaaAsiakas,
        isBetoniToimittaja: this.isBetoniToimittaja,
        isPumppuToimittaja: this.isPumppuToimittaja,
        isLattiaToimittaja: this.isLattiaToimittaja,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/asiakas/setRoolit",
      requestOptions
    );
    cache_clear(asiakasPerson_cacheName);
    if (!(await checkResponse(response).success)) return false;
  }

  asiakasError(allowEdit) {
    if (this.asiakasId === 0)
      if (allowEdit) return "Valitse tai syötä asiakastiedot";
      else return "Asiakastietoja ei ole";
    return null;
  }

  get hasToimitus() {
    return asiakasSettings_get(this, this.asiakasId, 8).asiakasSettingBool;
  }
  get hasLaskutus() {
    return asiakasSettings_get(this, this.asiakasId, 9).asiakasSettingBool;
  }
  get hasSijainnit() {
    return asiakasSettings_get(this, this.asiakasId, 5).asiakasSettingBool;
  }
  get hasAjoneuvot() {
    return asiakasSettings_get(this, this.asiakasId, 6).asiakasSettingBool;
  }
  get hasTuotteet() {
    return asiakasSettings_get(this, this.asiakasId, 7).asiakasSettingBool;
  }
  get hasTiedostot() {
    return asiakasSettings_get(this, this.asiakasId, 11).asiakasSettingBool;
  }
  get hasEcofleet() {
    return asiakasSettings_get(this, this.asiakasId, 15).asiakasSettingBool;
  }
  get hasHenkilöt() {
    return asiakasSettings_get(this, this.asiakasId, 4).asiakasSettingBool;
  }
  get hasTyö() {
    return asiakasSettings_get(this, this.asiakasId, 12).asiakasSettingBool;
  }
  get hasPumifi() {
    return asiakasSettings_get(this, this.asiakasId, 1).asiakasSettingBool;
  }
  get defaultVehicleId() {
    return asiakasSettings_get(this, this.asiakasId, 13).asiakasSettingInt;
  }
  set defaultVehicleId(value) {
    asiakasSetting_set(this, this.ownerAsiakasId, 13, true, value);
  }
  // get defaultDailyMessages() {
  //   const j = asiakasSettings_get(this, this.asiakasId, 14).asiakasSettingJSON;
  //   if (!j) return [];
  //   return JSON.parse(j);
  // }
  // set defaultDailyMessages(value) {
  //   asiakasSetting_set(this, this.asiakasId, 14, true, null, null, value);
  // }

  getSetting(asiakasSettingTypeId) {
    return asiakasSettings_get(this, this.asiakasId, asiakasSettingTypeId);
  }

  get asiakasCommonHash() {
    return (
      this.asiakasId * 3 +
      this.asiakasContactPersonId * 5 +
      this.sijaintiId * 7 +
      hashCode(this.asiakasNimi) +
      hashCode(this.ytunnus) +
      hashCode(this.kommentti)
    );
  }

  get asiakasUniqueHash() {
    return this.auth.asiakasAuthHash;
  }
  get asiakasHash() {
    return this.asiakasCommonHash + this.asiakasUniqueHash;
  }
}

export async function asiakasNimiList_add(asiakasId, asiakasNimi, token) {
  if (asiakasId == null || asiakasId == 0) return;
  try {
    const url = "/api/asiakas/nimiList/add";
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        asiakasId: asiakasId,
        asiakasNimi: asiakasNimi,
      }),
    };
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, requestOptions);
    const cResponse = await checkResponse(response, "asiakasClass.js:addToAsiakasNimiList");
    if (!cResponse.success) return false;
    cache_clear(asiakasPerson_cacheName);
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function asiakasNimiList_fetchList(asiakasId, token) {
  if (asiakasId == null || asiakasId == 0) return;
  try {
    const url = "/api/asiakas/nimiList/get/" + asiakasId;
    const fullUrl = import.meta.env.VITE_SERVER_URL + url;
    const c = cache_read(asiakasPerson_cacheName, fullUrl);
    if (c) return c;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:fetchAsiakasNimiList");
    if (!cResponse.success) return false;
    cache_write(asiakasPerson_cacheName, fullUrl, cResponse.data);
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function asiakasNimiList_delete(asiakasNimiListId, token) {
  try {
    const url = "/api/asiakas/nimiList/del/" + asiakasNimiListId;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:deleteFromAsiakasNimiList");
    if (!cResponse.success) return false;
    const result = cResponse.data;
    cache_clear(asiakasPerson_cacheName);
    return result;
  } catch (err) {
    console.log(err);
  }
}

export async function asiakasPerson_fetchList(asiakasId, token) {
  try {
    const url = "/api/asiakas/person/list/" + asiakasId;
    const fullUrl = import.meta.env.VITE_SERVER_URL + url;
    const c = cache_read(asiakasPerson_cacheName, fullUrl);
    if (c) return c;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:fetchAsiakasPersonList");
    if (!cResponse.success) return false;
    cache_write(asiakasPerson_cacheName, fullUrl, cResponse.data);
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function asiakasPerson_fetchLists(asiakasId, token, yyyymmdd = null) {
  try {
    if (yyyymmdd === null) yyyymmdd = getYYYYMMDD(new Date());
    const url = "/api/asiakas/person/lists/" + asiakasId + "/" + yyyymmdd;
    const fullUrl = import.meta.env.VITE_SERVER_URL + url;
    const c = cache_read(asiakasPerson_cacheName, fullUrl);
    if (c) return c;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:fetchAsiakasPersonList");
    if (!cResponse.success) return false;
    const data = cResponse.data;

    for (let i = 0; i < data.personList.length; i++) {
      const _person = data.personList[i];
      _person.asiakasPersonSettings = data.asiakasPersonSettings.filter(
        (item) => item.asiakasPersonId === _person.asiakasPersonId
      );
      let _personSettings = data.personSettings.filter(
        (item) => item.personId === _person.personId
      );
      const _psc = new personSettingsClass(_person.personId, null);
      for (let j = 0; j < _personSettings.length; j++) {
        const _setting = _personSettings[j];
        _psc.settings.push(_setting);
      }
      _person.personSettings = _psc.settings;
      _person.settings = _psc;
      data.personList[i].is = {};
      for (let j = 0; j < _person.asiakasPersonSettings.length; j++) {
        const _setting = _person.asiakasPersonSettings[j];

        _setting.startDate = parseJSONDate(_setting.startDate);
        _setting.endDate = parseJSONDate(_setting.endDate);
        const startYYYYMMDD = getYYYYMMDD(_setting.startDate);
        const endYYYYMMDD = getYYYYMMDD(_setting.endDate);
        // check if _setting is valid for date formatted as yyyymmdd or null
        const isValidForDate =
          (startYYYYMMDD === null || yyyymmdd >= startYYYYMMDD) &&
          (yyyymmdd <= endYYYYMMDD || endYYYYMMDD === null);
        if (isValidForDate) {
          if (_setting.asiakasPersonSettingTypeId === 8) _person.is.pumppari = true;
          if (_setting.asiakasPersonSettingTypeId === 9) _person.is.työsuhteessa = true;
          if (_setting.asiakasPersonSettingTypeId === 15) _person.is.lomaseurannassa = true;
          if (_setting.asiakasPersonSettingTypeId === 16) _person.is.assignee = true;
        }
      }
    }
    cache_write(asiakasPerson_cacheName, fullUrl, data);
    return data;
  } catch (err) {
    console.log(err);
  }
}

export function getLaskuttajaAsiakas(keikkaData, laskuttajaType = "pumppu") {
  if (!keikkaData) return null;
  if (laskuttajaType === "pumppu") return keikkaData.pumppuToimittaja;
  if (laskuttajaType === "betoni") return keikkaData.betoniToimittaja;
  if (laskuttajaType === "lattia") return keikkaData.lattiaToimittaja;
  return null;
}
